import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface WordCategory {
    event_category_idx: number;
    event_name: string;
}

export interface GetWordResponse {
    word_idx: number;
    wreath_word: string;
    search_word: string;
    status: boolean;
    category: WordCategory;
    reg_date: string;
}
export const useGetWordInfo = (wordId: number): UseQueryResult<GetWordResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetWordResponse, Error>({
        queryKey: ["getWordInfo", wordId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_word_info}/${wordId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!wordId,
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
